import { create } from 'zustand';
import { ITotoalSummaryInfo } from '../api/merchant';

const createShopInfoSlice = (set) => ({
    fetchShopData: () => 1,

    fetchStoreCartItem: () => 1,
    setFetchStoreCartItem: (fetchStoreCartItem) => set({ fetchStoreCartItem }),

    setState: (state: Record<string, any>) => {
        set(state);
    },
    tabsContent: [
        // { key: '0', text: $k18n({id: 'k_252266', text: '销量'}), tabType: 1 },
        // { key: '1', text: $k18n({ id: 'k_252267', text: '价格' }), sort: 'asc', tabType: 2 },
        { key: '0', text: 'k_252266', tabType: 1 },
        { key: '1', text: 'k_252267', sort: 'asc', tabType: 2 },
        // { key: '3', text: '推荐', tabType: 3 },
    ],
    setTabsContent: (tabsContent) => set({ tabsContent }),
    // tab选中第几个
    tabIndex: 0,
    setTabIndex: (tabIndex) => set({ tabIndex }),
    // 获取摘要信息以及第一屏的列表数据
    shopInfo: null as ITotoalSummaryInfo,
    setShopInfo: (shopInfo) => set({ shopInfo }),
    recoList: {
        items: [],
    },
    setRecoList: (recoList) => set({ recoList }),
    salesList: {
        items: [],
    },
    setSalesList: (salesList) => set({ salesList }),
    priceList: {
        items: [],
    },
    setPriceList: (priceList) => set({ priceList }),
});

const createShopCartSlice = (set) => ({
    // cartShopList: [],
    // setCartShopList: (cartShopList) => set({ cartShopList }),
    storeCartItem: null,
    setStoreCartItem: (storeCartItem) => set({ storeCartItem }),

    curPopCartItem: null,
    setCurPopCartItem: (curPopCartItem) => set({ curPopCartItem }),

    showSpecPop: false,
    setShowSpecPop: (showSpecPop) => set({ showSpecPop }),

    selectedInsufficient: false,
    setSelectedInsufficient: (selectedInsufficient) => set({ selectedInsufficient }),
});

type StoreType = ReturnType<typeof createShopInfoSlice>;

export const useShopInfoStore = create<StoreType>()((...args) => ({
    ...createShopInfoSlice(...args),
    ...createShopCartSlice(...args),
}));
